// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectionCursorBrowser_root__39PMt","container":"SelectionCursorBrowser_container__3hZe5","list":"SelectionCursorBrowser_list__14QGt"};